module.exports = __webpack_public_path__ + "img/coin-equals-to.1552a300.svg";